import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../../context/UserPrefs/UserPrefsContext";

import Select from "../../../../components/shared/InputElements/Select";

const SelectElectricityProvider = ({
  id = "electricity-provider",
  label="electricity-provider",
  location,
  ...rest
}) => {
  let power_suppliers = [];
  const blockList = ["Clearview Energy", "Champion Energy Services", "Chariot Energy", "Reliant Energy", "CPS Energy", "TXU Energy"];

  if (location) {
    location.power_supplier.forEach((spot) => {
      const isBlocked = blockList.some(blockedName =>
        spot.name.includes(blockedName)
      );
      if (isBlocked) return;
      power_suppliers.push(spot.name);
    });
  }
  const userPrefs = useContext(UserPrefsContext);

  return (
    <Select
      id={id}
      label={label}
      isSpecial={true}
      value={userPrefs.get("electricityProvider").toString()}
      optionNames={power_suppliers.length >= 1 ? power_suppliers : ["None"]}
      optionValues={power_suppliers.length >= 1 ? power_suppliers : ["None"]}
      handler={(e) => userPrefs.set({ electricityProvider: e.target.value })}
    />
  );
};

export default SelectElectricityProvider;

SelectElectricityProvider.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  tooltip: PropTypes.string,
};
